import {ModalNamesType} from 'constants/modals';
import * as types from 'app/actions/actionTypes';
import {AppSettings} from 'app/actions/actionTypes';

interface CommonDataState {
    auth: {
        isLoggedIn: boolean;
    };
    appSettings: AppSettings | null;
    modalData: {modalName: ModalNamesType; modalData: any} | undefined;
    showLoaderSpinner: boolean;
}

const getDefaultState = (initAuthData: any): CommonDataState => {
    const isLoggedIn = Boolean(initAuthData?.isLoggedIn);
    const defaultState: CommonDataState = {
        auth: {
            isLoggedIn,
        },
        modalData: undefined,
        showLoaderSpinner: false,
        appSettings: null,
    };
    return defaultState;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function wrapper(initAuthData: any) {
    const reducer = (state = getDefaultState(initAuthData), action: types.AppActionTypes): CommonDataState => {
        switch (action.type) {
            case types.USER_LOGGED_IN: {
                return {
                    ...state,
                    auth: {
                        isLoggedIn: true,
                    },
                };
            }

            case types.USER_LOGGED_OUT: {
                return {
                    ...state,
                    auth: {
                        isLoggedIn: false,
                    },
                };
            }

            case types.SHOW_LOADER_SPINNER: {
                return {
                    ...state,
                    showLoaderSpinner: true,
                };
            }

            case types.HIDE_LOADER_SPINNER: {
                return {
                    ...state,
                    showLoaderSpinner: false,
                };
            }

            case types.SHOW_MODAL: {
                return {
                    ...state,
                    modalData: action.payload,
                };
            }

            case types.HIDE_MODAL: {
                return {
                    ...state,
                    modalData: undefined,
                };
            }

            case types.APP_SETTINGS_RECEIVED: {
                return {
                    ...state,
                    appSettings: action.payload,
                };
            }

            default:
                return state;
        }
    };

    return reducer;
}
